export const config = {
  name: 'Amplio Web Portal',
  version: '2 5 47',
  lastUpdate: '11.03.2026 20:37 CEST',
  environment: process.env.REACT_APP_ENV,
}
